var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"oncontextmenu":"return false;","id":"app"}},[_c('div',{staticClass:"background",style:({
      backgroundImage: _vm.image ? 'url(' + _vm.image + ')' : 'none',
      backgroundColor: _vm.backgroundColor
    })}),_c('Skillcheck'),_c('GeneralStats'),_c('Generator'),_c('Combo'),_c('ObjectivePoints'),_c('Sidebar'),_c('Noise'),_c('UserInteractionButtons'),_c('Notifications'),_c('Rank'),_c('ActiveKillerPerks'),_c('LeftBottom'),_c('DevMenu'),_c('UpdateNotice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }